export default "__VITE_ASSET__CRTB4f3T__"